// extracted by mini-css-extract-plugin
module.exports = {"content":"HeroContent_content__k6u3C","logo":"HeroContent_logo__1HReQ","title":"HeroContent_title__GMQZW","text":"HeroContent_text__wMA96"};